import { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import PortalLayout from '../components/PortalLayout/PortalLayout'
import AppContext from '../context/AppContext'
import { getPortalBasePath } from '../helpers/customDomain/customDomain'
import useCheckOrder from '../hooks/useCheckOrder/useCheckOrder'
import usePortalPage from '../hooks/usePortalPage/usePortalPage'
import useRecoveryToken from '../hooks/useRecoveryToken/useRecoveryToken'
import useTransactionTypes from '../hooks/useTransactionTypes/useTransactionTypes'
import OrderErrorModal from '../MerchantHomePage/OrderErrorModal/OrderErrorModal'
import routes from '../Router/routes.constants'
import useRecoverableOrders from './hooks/useRecoverableOrders/useRecoverableOrders'
import RecoveredOrdersContent from './RecoveredOrdersContent/RecoveredOrdersContent'
import { getRecoveryTransactionType } from './helpers'

const RecoveredOrdersPage = () => {
  const { slug } = useParams()
  const portalBasePath = getPortalBasePath(slug)
  const navigate = useNavigate()
  const { context } = useContext(AppContext)
  const { loadingReturnPortalInfo, changeLanguage, descriptionText } = usePortalPage({
    slug,
    requiresOrderRecovery: true,
  })
  const { hasToken, isTokenExpired } = useRecoveryToken()
  const { allowedTransactionTypes, allowsUnifiedFlow } = useTransactionTypes()
  const { checkOrder, orderLoading, showOrderErrorModal, closeOrderErrorModal } = useCheckOrder({
    isGiftReturn: false,
    giftRecipient: null,
  })
  const { orders, loading, isLinkExpired, hasError } = useRecoverableOrders({ enabled: hasToken && !isTokenExpired })

  const [selectedOrderNumber, setSelectedOrderNumber] = useState(null)

  const isLinkInvalid = isTokenExpired || isLinkExpired

  useEffect(() => {
    if (!hasToken) navigate(`${portalBasePath}${routes.findOrdersPage}`)
    if (isLinkInvalid) navigate(portalBasePath || '/', { state: { linkExpired: true } })
  }, [hasToken, isLinkInvalid, navigate, portalBasePath])

  const handleSelectOrder = order => {
    setSelectedOrderNumber(order.number)

    checkOrder({
      orderNumber: order.number,
      identifier: order.customer_email,
      type: getRecoveryTransactionType({
        transactionTypes: allowedTransactionTypes,
        allowsUnifiedFlow,
      }),
    })
  }

  const handleBackToStart = () => navigate(portalBasePath || '/')

  return (
    <PortalLayout
      loading={loadingReturnPortalInfo}
      descriptionText={descriptionText}
      onChangeLanguage={changeLanguage}
      headerAboveCard
    >
      <RecoveredOrdersContent
        loading={loading}
        orders={orders}
        hasError={hasError}
        isSelecting={orderLoading}
        selectedOrderNumber={selectedOrderNumber}
        contactEmail={context.merchantInfo.contact_email}
        onSelectOrder={handleSelectOrder}
        onBackToStart={handleBackToStart}
      />
      <OrderErrorModal onClose={closeOrderErrorModal} show={showOrderErrorModal} />
    </PortalLayout>
  )
}

export default RecoveredOrdersPage
